import configDepv from '../components/depv/Header/constants';
import configDepi from '../components/depi/Header/constants';
import { LINKS } from '../components/enplus/constants';
import { transformEnplusLink } from '../namedRoutes';

const configPellets = transformEnplusLink(LINKS.pellets);
const configHolzbriketts = transformEnplusLink(LINKS.holzbriketts);
const configHackschnitzel = transformEnplusLink(LINKS.hackschnitzel);

const getRoutenConfiguration = context => {
  switch (context) {
    case 'pellets':
      return configPellets;
    case 'hackschnitzel':
      return configHackschnitzel;
    case 'holzbriketts':
      return configHolzbriketts;
    case 'depi':
      return configDepi;
    case 'depv':
      return configDepv
  }
};

export default getRoutenConfiguration;
